import { DaoModel } from '@dynameat/models';
import { ProductMasterModelLanguage } from '@productMaster/models/productMasterModelLanguage';
import { Product } from '@pointOfSale/models';

export class ProductMaster extends DaoModel {
  constructor(guid, name, description, referencePrice, soldByWeight, unitCost, maxRangePrice, minRangePrice, processingSpeed,
    consumptionPerPerson, image, saleWeightIndex, features, modelLanguage, products) {
    super(guid);
    this.name = name;
    this.description = description;
    this.referencePrice = referencePrice || 0;
    this.soldByWeight = soldByWeight || false;
    this.unitCost = unitCost || 0;
    this.maxRangePrice = maxRangePrice || 0;
    this.minRangePrice = minRangePrice || 0;
    this.processingSpeed = processingSpeed || 0;
    this.consumptionPerPerson = consumptionPerPerson || 0;
    this.image = image;
    this.saleWeightIndex = saleWeightIndex || 1;
    this.features = features || [];
    this.modelLanguage = modelLanguage;
    this.products = products || [];
  }

  static toInstance(props = {}) {
    const modelLanguage = ProductMasterModelLanguage.toInstanceList(props.model_languages);
    const products = Product.toInstanceList(props.products);
    return new ProductMaster(props.guid, props.name, props.description, props.reference_price,
      props.sold_by_weight, props.unit_cost, props.max_range_price, props.min_range_price, props.processing_speed,
      props.consumption_per_person, props.image, props.sale_weight_index, props.features, modelLanguage, products);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      description: this.description,
      reference_price: this.referencePrice,
      sold_by_weight: this.soldByWeight,
      unit_cost: this.unitCost,
      max_range_price: this.maxRangePrice,
      min_range_price: this.minRangePrice,
      processing_speed: this.processingSpeed,
      consumption_per_person: this.consumptionPerPerson,
      image: this.image,
      sale_weight_index: this.saleWeightIndex,
      features: this.features,
      model_languages: this.modelLanguage.map((each) => each.serialize()),
      products: this.products.map((each) => each.serialize()),
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('name', this.name);
    formData.append('description', this.description);
    formData.append('reference_price', this.referencePrice);
    formData.append('sold_by_weight', this.soldByWeight);
    formData.append('unit_cost', this.unitCost);
    formData.append('max_range_price', this.maxRangePrice);
    formData.append('min_range_price', this.minRangePrice);
    formData.append('processing_speed', this.processingSpeed);
    formData.append('consumption_per_person', this.consumptionPerPerson);
    formData.append('sale_weight_index', this.saleWeightIndex);
    formData.append('model_languages', JSON.stringify(this.modelLanguage.map((each) => each.serialize())));
    formData.append('products', JSON.stringify(this.products.map((each) => each.serialize())));

    this.features.forEach((feature) => {
      formData.append('features', feature);
    });

    if (this.image instanceof File) {
      if (this.image.size !== 0) {
        formData.append('image', this.image, this.image.name);
      }
    } else if (!this.image) {
      formData.append('image', '');
    }
    return formData;
  }
}
